import Vue from 'vue'
import Router from 'vue-router'
import KoukoDashi from './views/kouko_dashi.vue'
import Bunkazai from './views/Bunkazai.vue'
import WasenBunka from './views/WasenBunka.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/:lang/bunkazai',
      name: 'Bunkazai',
      component: Bunkazai
    },
    {
      path: '/:lang/wasenbunka',
      name: 'WasenBunka',
      component: WasenBunka
    },
    {
      path: '/:lang/:category',
      name: 'KoukoDashi',
      component: KoukoDashi
    },
    {
      path: '/:lang/:category/:id',
      name: 'KoukoDashiDetail',
      component: KoukoDashi
    },
    {
      path: '*',
      redirect: '/ja/bunkazai'
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // ID, カテゴリ、言語切り替え時には先頭へスクロール
    if (from.params.id != to.params.id
        || from.params.category != to.params.category
        || from.params.lang != to.params.lang)
    {
      return {x:0, y:0}
    }
  }
})
